import React from "react";
import Rating from "react-rating";
import "./Rating.css";

const NewRating = ({ ...props }) => <Rating {...props} />;
export default NewRating;